// Browser-side Supabase client. Uses the anon key (RLS-safe). Reads work
// unauth'd thanks to the public_read policies; writes only happen through
// auth'd users via Edge Functions, never raw SQL from the browser.

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Loud-fail at import time: if the env vars aren't set during local dev,
  // every query will silently 401 and the user has no idea why.
  // eslint-disable-next-line no-console
  console.error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy web/.env.example to web/.env and fill in your project values.",
  );
}

export const sb = createClient(SUPABASE_URL ?? "", SUPABASE_ANON_KEY ?? "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // magic-link callback ?token_hash=… in URL
  },
});
